import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./BlogsPage.css";
import Spinner from "../components/Spinner";
import Footer from "./footer";

export default function BlogsPage() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchBlogs() {
      try {
        const res = await fetch("https://api.goharesadaf.ir/api/blogs");
        const data = await res.json();
        setBlogs(Array.isArray(data) ? data : data.data ?? []);
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setError(err.message || "خطا در بارگذاری");
      } finally {
        setLoading(false);
      }
    }
    fetchBlogs();
  }, []);

  return (
    <div className="blogs-page">
      <div className="blogs-header">
        <h1>بلاگ‌ها</h1>
        <p>آخرین اخبار و مقالات صنایع دستی و هنر ایرانی را در گوهر صدف بخوانید.</p>
      </div>

      {loading && <Spinner />}
      {error && <p>خطا در بارگذاری: {error}</p>}

      <div className="blogs-grid">
        {blogs.map((blog) => (
          // whole card is a Link now — accessible and SPA-friendly
          <Link
            key={blog.id}
            to={`/blogs/${blog.slug}`}
            className="blog-card"
            aria-label={`باز کردن مطلب: ${blog.title}`}
          >
            {blog.image ? (
              <img src={blog.image} alt={blog.title} className="blog-image" />
            ) : (
              <div className="blog-image placeholder">عکسی موجود نیست</div>
            )}

            <div className="blog-content">
              <h2 className="blog-title">{blog.title}</h2>

              <p
                className="blog-text"
                // preview only — still clickable as a whole card
                dangerouslySetInnerHTML={{
                  __html:
                    blog.content && blog.content.length > 200
                      ? blog.content.substring(0, 200) + "..."
                      : blog.content || "",
                }}
              />

              <div className="blog-footer">
                {/* styled "button" but not interactive (anchor handles navigation) */}
                <span className="blog-button" aria-hidden="true">
                  ادامۀ مطلب
                </span>

                <span className="blog-date">
                  {blog.created_at
                    ? new Date(blog.created_at).toLocaleDateString("fa-IR")
                    : ""}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <Footer />
    </div>
  );
}
